import React, { useEffect, useRef, useState } from 'react';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';

export default function Range({ startValue, endValue, uniqueId, uuid, name, step = 1, currentValue, onChange }) {
    // Derive min/max from ROIPage props
    const min = Number(startValue?.value ?? 0);
    const max = Number(endValue?.value ?? 100);
    if(min > 0 || min < 1){
        step = min
    }
    // Initialize state with the first thumb fixed at min
  const initialUpper = Number.isFinite(Number(currentValue)) ? Number(currentValue) : max;
  const [value, setValue] = useState([min, initialUpper]);
  const latest = useRef([min, max]);
  const [isDragging, setIsDragging] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ percentage: 0, compensation: 0 });
  const sliderRef = useRef(null);
  const tooltipRef = useRef(null);

    // Sync internal state when min/max props change
  useEffect(() => {
    setValue(([, currentEnd]) => {
      const safeEnd = Math.min(Math.max(currentEnd, min), max);
      latest.current = [min, safeEnd];
      return [min, safeEnd];
    });
  }, [min, max]);

  // Sync when parent sends a new selected value
  useEffect(() => {
    if (Number.isFinite(Number(currentValue))) {
      const upper = Math.min(Math.max(Number(currentValue), min), max);
      const next = [min, upper];
      latest.current = next;
      setValue(next);
    }
  }, [currentValue, min, max]);

  // Update tooltip position based on current value
  useEffect(() => {
    if (sliderRef.current) {
      const slider = sliderRef.current.querySelector('.range-slider');
      if (slider) {
        const percentage = ((value[1] - min) / (max - min)) * 100;
        // Calculate position with thumb width compensation (similar to the example)
        // The formula accounts for the thumb width to center the tooltip above it
        const thumbWidthCompensation = 12 - (percentage * 0.24);
        setTooltipPosition({ percentage, compensation: thumbWidthCompensation });
      }
    }
  }, [value, min, max]);

    // Handle change event to only update the second value
  const handleInput = (newValue) => {
      const upper = Array.isArray(newValue) ? newValue[1] : Number(newValue);
      const next = [min, upper];
      latest.current = next;
      setValue(next);
      setIsDragging(true);
  };

  const handleThumbEnd = () => {
      const next = latest.current || value;
      setIsDragging(false);
      if (typeof onChange === 'function') onChange(uuid, next[1]);
  };

  const handleThumbDragStart = () => {
    setIsDragging(true);
  };

    const showTooltip = isDragging || isHovering;

    return (
        <div className="range-slider-custom" ref={sliderRef}>
            <div 
                className="range-slider-wrapper" 
                style={{ position: 'relative' }}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                <RangeSlider
                    id={uniqueId}
                    value={value}
                    min={min}
                    max={max}
                    step={step}
                    onInput={handleInput}
                    onThumbDragStart={handleThumbDragStart}
                    onThumbDragEnd={handleThumbEnd}
                    thumbsDisabled={[true, false]} // Keep the first thumb disabled
                />
                <div
                    ref={tooltipRef}
                    className={`range-slider-tooltip ${showTooltip ? 'visible' : ''}`}
                    style={{
                        left: `calc(${tooltipPosition.percentage}% + ${tooltipPosition.compensation}px)`,
                        opacity: showTooltip ? 1 : 0,
                        visibility: showTooltip ? 'visible' : 'hidden',
                    }}
                >
                    {value[1]}
                </div>
            </div>
            {name && (
                <input type="hidden" name={name} value={value[1]} />
            )}
            {/* <input
        type="range"
        id={uniqueId}
        name={uniqueId}         // 👈 gives it a real input name for form submission
        min={min}
        max={max}
        step={step}
        // value={value[1]}          // controls only the second value
        // onChange={handleChange}
        style={{ width: "100%" }}
      /> */}
            {/* <p>Value: {value[0]} - {value[1]}</p> */}
        </div>
    );
}
